import { Pipe, PipeTransform } from '@angular/core';
import { Filter, FilterTypes, MultilineTextFilter } from '@models/filter-types';

@Pipe({
    name: 'isMultilineTextFilter',
    standalone: false,
})
export class IsMultilineTextFilterPipe implements PipeTransform {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    transform(value: Filter<any>): value is MultilineTextFilter {
        return value?.Type === FilterTypes.MultilineTextFilterType;
    }
}
